import { Component, Input } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ProviderService } from 'src/app/swagger/api/provider.service';

@Component({
  selector: 'app-api-key-modal-component',
  templateUrl: './api-key-modal-component.component.html',
  styleUrls: ['./api-key-modal-component.component.scss'],
})
export class ApiKeyModalComponent {
  @Input() apiKey: string;
  @Input() providerId: number;
  @Input() isReadOnly: boolean;
  constructor(
    private modalController: ModalController,
    private toastController: ToastController,
    private providerManager: ProviderService,
    private translate: TranslateService
  ) {}

  async generateApiKey() {
    try {
      const response = await this.providerManager.createNewAPI(this.providerId).toPromise();
      this.apiKey = response && response.token ? response.token : null;
      this.showToast('API key successfully generated.');
    } catch (error) {
      console.error('Error generating API key', error);
      this.showToast('An error occurred while generating the API key.');
    }
  }

  async deleteApiKey() {
    try {
      await this.providerManager.deleteAPI(this.providerId).toPromise();
      this.apiKey = null;
      this.showToast('API key deleted.');
    } catch (error) {
      console.error('Error deleting API key', error);
      this.showToast('An error occurred while deleting the API key.');
    }
  }

  async copyToClipboard() {
    if (!this.apiKey) {
      this.showToast('No API key to copy.');
      return;
    }
  
    try {
      const textarea = document.createElement('textarea');
      textarea.value = this.apiKey;
      textarea.style.position = 'fixed';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      const successful = document.execCommand('copy');
      document.body.removeChild(textarea);
  
      if (successful) {
        this.showToast('API key copied to clipboard.');
      } else {
        this.showToast('Copy to clipboard failed.');
      }
    } catch (err) {
      console.error('Fallback clipboard copy failed', err);
      this.showToast('Copy to clipboard failed.');
    }
  }

  dismissModal() {
    this.modalController.dismiss(this.apiKey);
  }

  private async showToast(message: string) {
    const toast = await this.toastController.create({
      message: this.translate.instant(message),
      duration: 2000,
      position: 'bottom',
    });
    toast.present();
  }
}
